/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bus from '../../utils/bus';
export default {
  props: {
    offset: {
      type: Number,
      default: 40
    },
    loadingText: {
      type: String,
      default: '加载中...'
    },
    enableInfinite: {
      type: Boolean,
      default: true
    },
    enableRefresh: {
      type: Boolean,
      default: false
    },
    // 下拉加载
    onRefresh: {
      type: Function,
      default: undefined,
      required: false
    },
    // 上拉加载
    onInfinite: {
      type: Function,
      default: undefined,
      require: false
    }
  },
  data: function data() {
    return {
      top: 0,
      state: 0,
      startY: 0,
      touching: false,
      infiniteLoading: false,
      height: '',
      // tab页切换间解决高度问题 触发数据加载
      page_size: 2,
      page_total: 1
    };
  },
  mounted: function mounted() {
    var slef = this;
    this.$nextTick(function () {
      bus.$on('infiniteLoading', function (val) {
        slef.infiniteLoading = val;
        slef.height = 1330;
      });
      bus.$on('showFooter', function (val) {
        slef.page_total = val.total_page;
        slef.page_size = val.page_size;
      });
    });
  },
  methods: {
    touchStart: function touchStart(e) {
      this.startY = e.targetTouches[0].pageY;
      this.startScroll = this.$el.scrollTop || 0;
      this.touching = true;
    },
    touchMove: function touchMove(e) {
      if (!this.enableRefresh || this.$el.scrollTop > 0 || !this.touching) {
        return;
      }
      var diff = e.targetTouches[0].pageY - this.startY - this.startScroll;
      if (diff > 0) e.preventDefault();
      this.top = Math.pow(diff, 0.8) + (this.state === 2 ? this.offset : 0);
      if (this.state === 2) {
        // in refreshing
        return;
      }
      if (this.top >= this.offset) {
        this.state = 1;
      } else {
        this.state = 0;
      }
    },
    touchEnd: function touchEnd(e) {
      if (!this.enableRefresh) return;
      this.touching = false;
      if (this.state === 2) {
        // in refreshing
        this.state = 2;
        this.top = this.offset;
        return;
      }
      if (this.top >= this.offset) {
        // do refresh
        this.refresh();
      } else {
        // cancel refresh
        this.state = 0;
        this.top = 0;
      }
    },
    refresh: function refresh() {
      this.state = 2;
      this.top = this.offset;
      this.onRefresh(this.refreshDone);
    },
    refreshDone: function refreshDone() {
      this.state = 0;
      this.top = 0;
      this.infiniteLoading = false;
    },
    infinite: function infinite() {
      this.infiniteLoading = true;
      this.onInfinite(this.infiniteDone);
    },
    infiniteDone: function infiniteDone() {
      this.infiniteLoading = false;
    },
    onScroll: function onScroll(e) {
      if (!this.enableInfinite || this.infiniteLoading) {
        return;
      }
      var outerHeight = this.$el.clientHeight;
      var innerHeight = this.height ? this.height : this.$el.querySelector('.inner').clientHeight;
      var scrollTop = this.$el.scrollTop;
      var ptrHeight = this.onRefresh ? this.$el.querySelector('.pull-refresh').clientHeight : 0;
      var infiniteHeight = this.$el.querySelector('.load-more').clientHeight;
      var bottom = innerHeight - outerHeight - scrollTop - ptrHeight;
      this.height = false;
      if (bottom < infiniteHeight) this.infinite();
    }
  }
};